import * as types from '@/store/mutation-types'
export default {
	namespaced: true,

	state: {
		versions: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/projectVersion').then(({ data }) => {
				commit(types.STORE_VERSIONS, data)
				return data
			})
		},
		fetchProjectVersions ({ commit }, { isArchived }) {
			return window.axios.get('/projectVersion/Archived', { params: { isArchived } }).then(({ data }) => {
				return data
			})
		},

		fetchByProjectId ({ commit }, { projectId, isActive }) {
			return window.axios.get(`/projectVersion/${projectId}`, { params: { isActive } }).then(({ data }) => {
				return data
			})
		},

		create ({ commit }, { name, contractDate, startDate, endDate, projectId, isArchived, isActive }) { 
			return window.axios.post('/projectVersion', { name, contractDate, startDate, endDate, projectId, isArchived, isActive }).then(({ data }) => {
				return data
			})
		}
	},

	mutations: {
		[types.STORE_VERSIONS] (state, versions) {
			state.versions = versions
		}
	},

	getters: {
		getVersionById: state => id => state.versions.find(c => c.id === id)
	}
}
